import PropTypes from 'prop-types';

import { Typography } from '@mui/material';

import Actions from './ActionsComponent';

const InfoModal = (props) => {
  const { bodyText, onConfirm, confirmText } = props;
  const actions = [
    {
      label: confirmText || 'Ok',
      onClick: onConfirm,
      color: 'primary',
    },
  ];
  return (
    <>
      <Typography variant="body1" component="div">
        {bodyText || ''}
      </Typography>
      <Actions actions={actions} />
    </>
  );
};
InfoModal.defaultProps = {
  confirmText: null,
  bodyText: null,
};
InfoModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  confirmText: PropTypes.string,
  bodyText: PropTypes.oneOfType([
    PropTypes.instanceOf(Object),
    PropTypes.string,
  ]),
};

export default InfoModal;
